import styled, { css } from "styled-components";
import { INotificationStyleProps } from "./interfaces";

export const StyledNotifications = styled.div`
    position: fixed;
    top: 50px;
    z-index: 101;
    ${p =>
        p.theme.xs(css`
            width: 100%;
        `)}
    ${p =>
        p.theme.sm.min(css`
            width: ${p.theme.$screenSm - 15}px;
            left: calc((100vw - ${p.theme.$screenSm}px) / 2);
        `)}
    ${p =>
        p.theme.md.min(css`
            width: ${p.theme.$screenMd - 15}px;
            left: calc((100vw - ${p.theme.$screenMd}px) / 2);
        `)}
    ${p =>
        p.theme.lg(css`
            width: ${p.theme.$screenLg - 15}px;
            left: calc((100vw - ${p.theme.$screenLg}px) / 2);
        `)}
`;

export const Wrapper = styled.div`
    padding: 20px;
`;

export const StyledNotification = styled.div<INotificationStyleProps>`
    background-color: ${p => (p.severity === "warning" ? p.theme.c.info : p.theme.c.wrong)};
    border-radius: 8px;
    padding: 10px;
    padding-right: 32px;
    color: ${p => p.theme.c.white};
    box-shadow: 0 0 4px 0 ${p => p.theme.c.blackShadow3};
    position: relative;
    margin-bottom: 12px;
    text-shadow: 0 0 ${p => (p.severity === "warning" ? 3 : 0)}px ${p => p.theme.c.blackShadow5};
`;

export const Close = styled.button`
    position: absolute;
    top: 0;
    right: 0;
    color: ${p => p.theme.c.white};
    line-height: 40px;
    width: 40px;
    text-align: center;
    font-size: 24px;
    font-weight: 300;
    outline: none;
    background: transparent;
    border: none;
    padding: 0;
    cursor: pointer;
`;

export const NotificationButton = styled.button`
    background-color: transparent;
    font-family: inherit;
    color: ${p => p.theme.c.white};
    border-radius: 4px;
    border: 2px solid ${p => p.theme.c.white};
    font-size: 14px;
    padding: 2px 6px;
    margin-left: 8px;
    cursor: pointer;
    outline: none;
`;
